import {isRejectedWithValue, Middleware} from "@reduxjs/toolkit";
import SnackbarUtils from "../components/SnackbarUtilsConfigurator";
import {t} from "i18next";
import {ResponseErrorAlert} from "../components/ResponseErrorMessages";
import React from "react";
import {ErrorMessage} from "./api/types";

/**
 * Redux middleware that shows RTK Query errors as notistack notification.
 */
const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
    if (isRejectedWithValue(action) && action.payload?.status !== 401) {
        if (action.payload?.data?.messages?.length > 0) {
            action.payload?.data?.messages.map((m: ErrorMessage) =>
                SnackbarUtils.error(<ResponseErrorAlert title={t(m.title)} body={t(m.body, {...m?.params})} />, {
                    variant: "error",
                })
            );
        } else if (action.payload?.error) {
            SnackbarUtils.error(<ResponseErrorAlert title={t(action.payload?.error)} body={""} />, {variant: "error"});
        } else {
            SnackbarUtils.error(<ResponseErrorAlert title={t("errorBody_generalError")} body={""} />, {
                variant: "error",
            });
        }
    }

    return next(action);
};

export default rtkQueryErrorLogger;
